// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { useCallback, useState, type FC } from 'react';
import { Outlet } from 'react-router';
import { SilverAlphaTopbar } from './topbar';
import { SilverAlphaWelcomeModal } from './welcome-modal';
import styles from './silver-alpha.module.css';

/**
 * Silver Alpha shell. Availability (proposals required) is enforced by
 * `silverAlphaLoader` on the `/silver-alpha` route.
 *
 * Topbar, tabs, and page content stay gated until the welcome modal is accepted and
 * closed.
 */
export const SilverAlpha: FC = () => {
  const [hasAcceptedWelcome, setHasAcceptedWelcome] = useState(false);

  const onWelcomeAccepted = useCallback(() => {
    setHasAcceptedWelcome(true);
  }, []);

  return (
    <div className={styles.shell} data-testid="silver-alpha">
      <SilverAlphaWelcomeModal onAccepted={onWelcomeAccepted} />
      {hasAcceptedWelcome ? (
        <div className={styles.frame}>
          <SilverAlphaTopbar />
          <div className={styles.main}>
            <Outlet />
          </div>
        </div>
      ) : null}
    </div>
  );
};
